var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.73 40.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0b5580;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #0b5580;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.4px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pagina_principal",
    "data-name": "Pagina principal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.19,0H8.54C3.83,0,0,3.83,0,8.54v23.9c0,4.71,3.83,8.54,8.54,8.54h13.66c4.71,0,8.54-3.83,8.54-8.54V8.54C30.73,3.83,26.9,0,22.19,0Zm-1.71,3.41c0,.94-.77,1.71-1.71,1.71h-6.83c-.94,0-1.71-.77-1.71-1.71h10.24Zm6.83,29.02c0,2.82-2.3,5.12-5.12,5.12H8.54c-2.82,0-5.12-2.3-5.12-5.12V8.54c0-2.23,1.45-4.12,3.45-4.82,.16,2.68,2.37,4.82,5.09,4.82h6.83c2.72,0,4.93-2.14,5.09-4.82,2,.7,3.45,2.58,3.45,4.82v23.9Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "8.09 22.06 15.12 30.44 23.22 13.95"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon_2.a554848ee3b0521cb049b6fa806ea7fd.svg";
export { ForwardRef as ReactComponent };